import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useRef, useEffect } from "react";
import { IconButton, Icon, HStack, Input, Text, Textarea, FormHelperText } from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import { FormControl } from "formik-chakra-ui";
import { validateSchema } from "@inspire/data/helpers/schemas";
import SimpleSchema from "@inspire/data/schemas/SimpleSchema";
import { CheckIcon, EditIcon } from "@inspire/ui/icons";
export var StandaloneInput = function(_param) {
    var onSubmit = _param.onSubmit, onError = _param.onError, initialValue = _param.initialValue, _formik = _param.formik, formik = _formik === void 0 ? {} : _formik, label = _param.label, _isRequired = _param.isRequired, isRequired = _isRequired === void 0 ? false : _isRequired, _maxW = _param.maxW, maxW = _maxW === void 0 ? 400 : _maxW, _schema = _param.schema, schema = _schema === void 0 ? {} : _schema, _type = _param.type, type = _type === void 0 ? "text" : _type, renderValue = _param.renderValue, isTextArea = _param.isTextArea, maxLength = _param.maxLength, helperText = _param.helperText, isReadOnly = _param.isReadOnly, _isNegative = _param.isNegative, isNegative = _isNegative === void 0 ? false : _isNegative, formControlProps = _object_without_properties(_param, [
        "onSubmit",
        "onError",
        "initialValue",
        "formik",
        "label",
        "isRequired",
        "maxW",
        "schema",
        "type",
        "renderValue",
        "isTextArea",
        "maxLength",
        "helperText",
        "isReadOnly",
        "isNegative"
    ]);
    var ref = useState(false), isEditing = ref[0], setIsEditing = ref[1];
    // This is to keep track of the last value and prevent
    // submitting if the value did not change.
    var ref1 = useState(initialValue), valueWhenClickEdit = ref1[0], setValueWhenClickEdit = ref1[1];
    var inputRef = useRef(null);
    var formikConfig = _object_spread_props(_object_spread({}, formik), {
        validate: function(values) {
            return validateSchema(new SimpleSchema({
                main: schema
            }), {
                main: values.main
            });
        },
        initialValues: {
            main: initialValue || ""
        },
        enableReinitialize: true,
        onSubmit: function() {
            var _ref = _async_to_generator(function(values) {
                var value, err;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            value = values.main;
                            if (!(value !== valueWhenClickEdit)) return [
                                3,
                                4
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                onSubmit(value)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            err = _state.sent();
                            onError && onError(err);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            setIsEditing(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(values) {
                return _ref.apply(this, arguments);
            };
        }()
    });
    useEffect(function() {
        var ref;
        isEditing && ((ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.focus());
    }, [
        isEditing
    ]);
    return /*#__PURE__*/ _jsx(Formik, _object_spread_props(_object_spread({}, formikConfig), {
        children: function(param) {
            var isSubmitting = param.isSubmitting, values = param.values;
            return /*#__PURE__*/ _jsx(Form, {
                children: /*#__PURE__*/ _jsxs(FormControl, _object_spread_props(_object_spread({
                    name: "main",
                    label: label,
                    isRequired: isEditing && isRequired
                }, formControlProps), {
                    children: [
                        /*#__PURE__*/ _jsxs(HStack, {
                            maxW: maxW,
                            children: [
                                isEditing ? /*#__PURE__*/ _jsx(Field, {
                                    name: "main",
                                    children: function(param) {
                                        var field = param.field;
                                        return isTextArea ? /*#__PURE__*/ _jsx(Textarea, _object_spread_props(_object_spread({
                                            type: type
                                        }, field), {
                                            ref: inputRef,
                                            maxLength: maxLength
                                        })) : /*#__PURE__*/ _jsx(Input, _object_spread_props(_object_spread({
                                            type: type
                                        }, field), {
                                            ref: inputRef,
                                            maxLength: maxLength
                                        }));
                                    }
                                }) : /*#__PURE__*/ _jsx(_Fragment, {
                                    children: renderValue ? renderValue(values.main) : /*#__PURE__*/ _jsx(Text, {
                                        m: 0,
                                        py: 2,
                                        children: values.main
                                    })
                                }),
                                isEditing ? /*#__PURE__*/ _jsx(IconButton, {
                                    "aria-label": "Enregistrer",
                                    type: "submit",
                                    isLoading: isSubmitting,
                                    icon: /*#__PURE__*/ _jsx(Icon, {
                                        as: CheckIcon
                                    })
                                }) : !isReadOnly ? /*#__PURE__*/ _jsx(IconButton, _object_spread_props(_object_spread({
                                    "aria-label": "Modifier",
                                    onClick: function(e) {
                                        e.preventDefault();
                                        setIsEditing(true);
                                        setValueWhenClickEdit(values.main);
                                    }
                                }, isNegative ? {} : {
                                    variant: "ghost"
                                }), {
                                    icon: /*#__PURE__*/ _jsx(Icon, {
                                        as: EditIcon
                                    })
                                })) : /*#__PURE__*/ _jsx("span", {
                                    children: " "
                                })
                            ]
                        }),
                        helperText && /*#__PURE__*/ _jsx(FormHelperText, {
                            children: helperText
                        })
                    ]
                }))
            });
        }
    }));
};
export default StandaloneInput;
